import ungapStructuredClone from '@ungap/structured-clone';

export const initStructuredClonePolyfill = () => {
  if (!('structuredClone' in globalThis)) {
    // @ts-expect-error
    globalThis.structuredClone = ungapStructuredClone;
  }
};
